import { MdHome, MdWork, MdCode, MdSchool, MdPerson, MdEmail } from "react-icons/md";

/**
 * Configuración centralizada de navegación
 * Se usa en Header, Footer y cualquier componente que necesite la lista de navegación
 */
export const navItems = [
    {
        id: "inicio",
        label: "Inicio",
        href: "#inicio",
        icon: MdHome,
        type: "internal",
    },
    {
        id: "experiencia",
        label: "Experiencia",
        href: "#experiencia",
        icon: MdWork,
        type: "internal",
    },
    {
        id: "proyectos",
        label: "Proyectos",
        href: "#proyectos",
        icon: MdCode,
        type: "internal",
    },
    {
        id: "certificaciones",
        label: "Certificaciones",
        href: "#certificaciones",
        icon: MdSchool,
        type: "internal",
    },
    {
        id: "sobre-mi",
        label: "Sobre mí",
        href: "#sobre-mi",
        icon: MdPerson,
        type: "internal",
    },
    {
        id: "contacto",
        label: "Contacto",
        href: "#contacto",
        icon: MdEmail,
        type: "internal",
    },
];
